// Pitch Craft Gear - Quality Musical Instruments & Music Gear
// Brand operator: Arah Capital Group LLC
// Catalog & product copy sourced from theonlinetuningmarket.com

// ============================================
// SITE IMAGES - Musical instruments / studio theme (stored locally, brand-free stock)
// ============================================
export const siteImages = {
  heroMain: '/banners/hero.jpg',
  heroSecondary: '/banners/promo-audio.jpg',
  heroLifestyle: '/banners/about.jpg',
  ctaBackground: '/banners/cta.jpg',
  featuredBackground: '/banners/cta.jpg',
  powerBackground: '/banners/promo-audio.jpg',
  shopBanner: '/banners/shop.jpg',
  aboutBanner: '/banners/about.jpg',
  contactBanner: '/banners/contact.jpg',
  returnsBanner: '/banners/shop.jpg',
  privacyBanner: '/banners/about.jpg',
};

export const SHIPPING_NOTICE = 'Free USPS shipping across the United States';
export const SHIPPING_COUNTRIES = ['US'];
export const SHIPPING_METHOD = 'USPS';
export const SHIPPING_TIME = '2-4 business days';
export const FREE_SHIPPING_THRESHOLD = 0; // Free shipping on all orders

export const CARD_DESCRIPTOR = '8335851726pitchcraftgear';
export const HOSTING_PROVIDER = 'Hostinger';

export const CONTACT_INFO = {
  phone: '(833) 585-1726',
  email: 'contactus@pitchcraftgear.com',
  corpName: 'Arah Capital Group LLC',
  address: {
    street: '1331 W Haddington Ct',
    city: 'Palatine',
    state: 'IL',
    zip: '60067-6616',
    country: 'United States'
  }
};

// Return address must remain unchanged.
export const RETURN_ADDRESS = {
  street: '4711 34th St. N. Suite F',
  city: 'St. Petersburg',
  state: 'FL',
  zip: '33714',
  country: 'USA'
};

// ============================================
// MUSICAL INSTRUMENT CATALOG (14 Products)
// Prices fixed to required processor MID points:
//   $9.63, $12.84, $19.26, $19.37, $28.89, $58.11, $77.48,
//   $142.16, $227.48, $318.72, $489.36, $612.44, $784.88, $999.00
// Product names, images and descriptions sourced from theonlinetuningmarket.com
// ============================================
export const products = [
  // ===== ACCESSORIES =====
  {
    id: "drumstick-bag",
    name: "Drumstick Bag",
    slug: "drumstick-bag",
    sku: "PCG-ACC-001",
    price: 9.63,
    image: "/products/instruments/drumstick-bag.webp",
    badge: "Deal",
    categoryId: "accessories",
    categorySlug: "accessories",
    description: "Keep your sticks, mallets and brushes organized and protected with this spacious drumstick bag. Boasting a generous 24mm depth, it offers ample room for a full arsenal of sticks while the durable water-resistant shell shrugs off the wear and tear of gig life.",
    keyBenefits: ["Spacious 24mm-deep storage", "Water-resistant durable shell", "Clips to your floor tom or hardware"],
    usage: "Slide your sticks and mallets inside, roll or zip it closed, then hang it from your kit or drop it in your gig bag.",
    features: ["24mm Depth", "Water-Resistant", "Multi-Pocket", "Hardware Hook"],
    inStock: true
  },
  {
    id: "guitar-locking-tuners",
    name: "6pcs Guitar Locking Tuners",
    slug: "guitar-locking-tuners",
    sku: "PCG-ACC-002",
    price: 19.26,
    image: "/products/instruments/guitar-locking-tuners.jpg",
    badge: "Popular",
    categoryId: "accessories",
    categorySlug: "accessories",
    description: "Elevate your guitar's tuning stability with this set of six high-precision locking tuners. The locking design pins the string in place for rock-solid tuning, faster string changes and confident bends that snap right back to pitch.",
    keyBenefits: ["Set of 6 locking machine heads", "Rock-solid tuning stability", "Faster, cleaner string changes"],
    usage: "Fit each tuner to your headstock, thread the string, lock it down and tune \u2014 no more messy wraps.",
    features: ["Set of 6", "Locking Design", "Sealed Gears", "Chrome Finish"],
    inStock: true
  },

  // ===== DRUMS & PERCUSSION =====
  {
    id: "digital-electronic-drum-pad",
    name: "Digital Electronic Drum Pad",
    slug: "digital-electronic-drum-pad",
    sku: "PCG-DRM-001",
    price: 12.84,
    image: "/products/instruments/digital-electronic-drum-pad.webp",
    badge: "Best Value",
    categoryId: "drums-percussion",
    categorySlug: "drums-percussion",
    description: "Crafted from premium ABS plastic, this compact digital drum pad delivers responsive, quiet practice wherever you are. Built-in tones and a headphone output let you drum for hours without disturbing the household.",
    keyBenefits: ["Durable premium ABS build", "Quiet, apartment-friendly practice", "Built-in tones and headphone out"],
    usage: "Power it on, plug in headphones and tap out rhythms with your sticks or fingertips anytime.",
    features: ["ABS Build", "Built-in Tones", "Headphone Out", "Portable"],
    inStock: true
  },
  {
    id: "drum-practice-pad",
    name: "Silent Drum Practice Pad",
    slug: "drum-practice-pad",
    sku: "PCG-DRM-002",
    price: 19.37,
    image: "/products/instruments/drum-pad.jpg",
    badge: "Best Seller",
    categoryId: "drums-percussion",
    categorySlug: "drums-percussion",
    description: "Hone your drumming skills anytime, anywhere with this silent drum practice pad. The dense rubber surface returns a natural, realistic rebound that sharpens your stick control, speed and accuracy \u2014 all without waking the neighbors.",
    keyBenefits: ["Realistic natural rebound", "Near-silent practice surface", "Perfect for warm-ups and rudiments"],
    usage: "Set it on a table or snare stand, grab your sticks and drill your rudiments in near silence.",
    features: ["Dense Rubber", "Silent", "Non-Slip Base", "Stand-Mountable"],
    inStock: true
  },
  {
    id: "handpan-steel-drum",
    name: "Handpan Steel Drum Set",
    slug: "handpan-steel-drum",
    sku: "PCG-DRM-003",
    price: 142.16,
    image: "/products/instruments/steel-drum.jpg",
    badge: "Popular",
    categoryId: "drums-percussion",
    categorySlug: "drums-percussion",
    description: "Step into a serene soundscape with this enchanting handpan steel drum. Each hand-tuned note rings with a meditative, bell-like resonance, making it a favorite for relaxation, sound healing and intuitive melodic play \u2014 no prior training needed.",
    keyBenefits: ["Hand-tuned meditative tones", "Beginner-friendly, no theory needed", "Includes carry bag and mallets"],
    usage: "Rest it on your lap, strike the tone fields with your hands or the mallets and let the melodies flow.",
    features: ["Hand-Tuned", "Carry Bag", "Mallets Included", "Steel Alloy"],
    inStock: true
  },
  {
    id: "professional-concert-snare-drum",
    name: "Professional Concert Snare Drum",
    slug: "professional-concert-snare-drum",
    sku: "PCG-DRM-004",
    price: 999.00,
    image: "/products/instruments/snare-drum.jpg",
    badge: "Flagship",
    categoryId: "drums-percussion",
    categorySlug: "drums-percussion",
    description: "Elevate your percussion performance with this professional concert snare drum. Designed for the demands of the concert hall, it delivers crisp articulation, a wide dynamic range and a refined, sensitive snare response worthy of any ensemble.",
    keyBenefits: ["Crisp concert-hall articulation", "Wide, sensitive dynamic range", "Premium tunable shell and hardware"],
    usage: "Mount it on a stand, fine-tune the heads and snares, then play with mallets, brushes or sticks.",
    features: ["Concert Grade", "Tunable Heads", "Sensitive Snares", "Pro Hardware"],
    inStock: true
  },

  // ===== STUDIO & AUDIO GEAR =====
  {
    id: "mini-sound-mixer",
    name: "Mini Sound Mixer",
    slug: "mini-sound-mixer",
    sku: "PCG-AUD-001",
    price: 28.89,
    image: "/products/instruments/mini-sound-mixer.jpg",
    badge: "Pro Pick",
    categoryId: "studio-audio",
    categorySlug: "studio-audio",
    description: "Transform your streaming, podcasting or gaming setup with this Mini Sound Mixer. Blend microphones, instruments and playback in real time, add quick effects and dial in a clean, balanced mix from a compact desktop footprint.",
    keyBenefits: ["Real-time multi-input mixing", "Compact desktop footprint", "Great for streaming and podcasts"],
    usage: "Connect your mic and sources, set your levels on the faders and route the mix to your computer or speakers.",
    features: ["Multi-Input", "Live Effects", "USB Output", "Compact"],
    inStock: true
  },
  {
    id: "wood-color-record-player",
    name: "Wood Color Record Player",
    slug: "wood-color-record-player",
    sku: "PCG-AUD-002",
    price: 58.11,
    image: "/products/instruments/record-player.webp",
    badge: "Best Value",
    categoryId: "studio-audio",
    categorySlug: "studio-audio",
    description: "Bring warm analog sound into your space with this retro-styled turntable in a natural wood finish. Built-in stereo speakers make it ready to play right out of the box, while the classic design looks at home on any shelf.",
    keyBenefits: ["Warm authentic analog sound", "Built-in stereo speakers", "Timeless natural wood styling"],
    usage: "Place a record on the platter, set the needle and enjoy \u2014 or connect it to your speakers for a bigger sound.",
    features: ["Built-in Speakers", "3-Speed", "Wood Finish", "Plug & Play"],
    inStock: true
  },

  // ===== WOODWINDS & BRASS =====
  {
    id: "swan-harmonica-set",
    name: "Swan 7-Piece Diatonic Harmonica Set",
    slug: "swan-harmonica-set",
    sku: "PCG-WND-001",
    price: 77.48,
    image: "/products/instruments/harmonica-set.jpg",
    badge: "Popular",
    categoryId: "woodwinds-brass",
    categorySlug: "woodwinds-brass",
    description: "Cover every major key with this comprehensive seven-harmonica collection from Swan. Each ten-hole diatonic harp offers bright, expressive tone and airtight response, and the full set ships in a protective case ready for the stage or the road.",
    keyBenefits: ["Covers all seven major keys", "Bright, airtight response", "Protective travel case included"],
    usage: "Pick the harmonica in your song's key, cup it in your hands and play \u2014 draw and blow across the holes.",
    features: ["7 Keys", "10 Holes Each", "Travel Case", "Brass Reeds"],
    inStock: true
  },
  {
    id: "elite-concert-flute",
    name: "Elite Concert Flute in Silver",
    slug: "elite-concert-flute",
    sku: "PCG-WND-002",
    price: 318.72,
    image: "/products/instruments/concert-flute.jpg",
    badge: "Premium",
    categoryId: "woodwinds-brass",
    categorySlug: "woodwinds-brass",
    description: "Experience exceptional clarity and responsiveness with this Elite Concert Flute in a lustrous silver finish. Precision key work and a refined embouchure plate reward players with effortless projection and a sweet, singing tone across the range.",
    keyBenefits: ["Bright, projecting concert tone", "Smooth, precise key action", "Elegant silver-plated finish"],
    usage: "Assemble the three sections, align the keys, shape your embouchure over the lip plate and play.",
    features: ["Silver-Plated", "16 Keys", "Offset G", "Hard Case"],
    inStock: true
  },
  {
    id: "maestro-clarinet",
    name: "Maestro Clarinet",
    slug: "maestro-clarinet",
    sku: "PCG-WND-003",
    price: 612.44,
    image: "/products/instruments/clarinet.jpg",
    badge: "Editor's Choice",
    categoryId: "woodwinds-brass",
    categorySlug: "woodwinds-brass",
    description: "Unleash the sweet symphony of the woodwinds with this exquisitely crafted Maestro Clarinet. A resonant body and finely regulated keys deliver a warm, focused tone and reliable intonation \u2014 an inspiring choice for students and seasoned players alike.",
    keyBenefits: ["Warm, focused woodwind tone", "Reliable intonation and response", "Complete with case and accessories"],
    usage: "Fit a reed to the mouthpiece, assemble the joints, cover the tone holes and let the melodies breathe.",
    features: ["Bb Clarinet", "17 Keys", "Case Included", "Reed & Ligature"],
    inStock: true
  },

  // ===== GUITARS & STRINGS =====
  {
    id: "lyre-harp",
    name: "Handcrafted 16-String Mahogany Lyre Harp",
    slug: "lyre-harp",
    sku: "PCG-STR-001",
    price: 227.48,
    image: "/products/instruments/lyre-harp.jpg",
    badge: "New",
    categoryId: "guitars-strings",
    categorySlug: "guitars-strings",
    description: "Discover the enchanting sound of this 16-string lyre harp, meticulously shaped from solid mahogany. Its resonant body and clear, shimmering strings make it a joy for beginners and a soothing companion for meditation, songwriting and gentle play.",
    keyBenefits: ["Solid mahogany resonant body", "16 clear, shimmering strings", "Includes tuning wrench and case"],
    usage: "Rest the harp against your chest, pluck the strings with your fingers and tune with the included wrench.",
    features: ["Solid Mahogany", "16 Strings", "Tuning Wrench", "Carry Bag"],
    inStock: true
  },
  {
    id: "full-size-viola",
    name: "Full-Size Viola",
    slug: "full-size-viola",
    sku: "PCG-STR-002",
    price: 489.36,
    image: "/products/instruments/viola.jpg",
    badge: "Premium",
    categoryId: "guitars-strings",
    categorySlug: "guitars-strings",
    description: "Step into the rich mid-range of the string family with this full-size viola. Built with a spruce top and maple back, it delivers the warm, throaty voice that orchestras and chamber groups rely on \u2014 shipped ready to play with bow, case and rosin.",
    keyBenefits: ["Warm, rich mid-range voice", "Spruce top with maple back", "Bow, case and rosin included"],
    usage: "Rosin the bow, tune the strings, tuck the viola under your chin and draw out its warm tone.",
    features: ["Spruce Top", "Maple Back", "Bow & Rosin", "Hard Case"],
    inStock: true
  },
  {
    id: "guitar-starter-set",
    name: "All-In-One Acoustic Electric Guitar Starter Set",
    slug: "guitar-starter-set",
    sku: "PCG-STR-003",
    price: 784.88,
    image: "/products/instruments/guitar-starter-set.jpg",
    badge: "Pro Kit",
    categoryId: "guitars-strings",
    categorySlug: "guitars-strings",
    description: "Embark on your musical journey with this All-In-One Acoustic Electric Guitar Starter Set. The full-size instrument plays acoustically or plugs straight into an amp, and the bundle rounds out everything a new player needs to start strumming today.",
    keyBenefits: ["Play acoustic or plug in", "Complete beginner-ready bundle", "Comfortable, full-size playability"],
    usage: "Tune up and strum acoustically, or connect the built-in pickup to an amp for a bigger, brighter sound.",
    features: ["Acoustic-Electric", "Full Bundle", "Built-in Pickup", "Gig Bag"],
    inStock: true
  },
];

export const categories = [
  {
    id: "guitars-strings",
    name: "Guitars & Strings",
    slug: "guitars-strings",
    description: "Guitars, violas, harps and stringed instruments crafted for warm, expressive tone",
    image: "/products/instruments/guitar-starter-set.jpg",
    productCount: 3
  },
  {
    id: "drums-percussion",
    name: "Drums & Percussion",
    slug: "drums-percussion",
    description: "Snares, practice pads, handpans and percussion built for rhythm and control",
    image: "/products/instruments/steel-drum.jpg",
    productCount: 4
  },
  {
    id: "woodwinds-brass",
    name: "Woodwinds & Brass",
    slug: "woodwinds-brass",
    description: "Flutes, clarinets and harmonicas tuned for clear, singing projection",
    image: "/products/instruments/concert-flute.jpg",
    productCount: 3
  },
  {
    id: "studio-audio",
    name: "Studio & Audio Gear",
    slug: "studio-audio",
    description: "Mixers, turntables and studio essentials to capture and enjoy great sound",
    image: "/products/instruments/mini-sound-mixer.jpg",
    productCount: 2
  },
  {
    id: "accessories",
    name: "Accessories",
    slug: "accessories",
    description: "Tuners, stick bags and the small essentials that keep you playing",
    image: "/products/instruments/guitar-locking-tuners.jpg",
    productCount: 2
  },
];

// ============================================
// FEATURES / WHY CHOOSE US
// ============================================
export const features = [
  { id: 1, title: 'Handpicked Instruments', description: 'A tight, curated lineup of instruments and gear worth playing \u2014 no filler, no guesswork' },
  { id: 2, title: 'Free USA Shipping', description: 'Free USPS Standard Shipping on every order, no minimum required' },
  { id: 3, title: '30-Day Returns', description: 'Changed your tune? Send it back within 30 days, hassle-free' },
  { id: 4, title: 'Secure Checkout', description: 'Encrypted payments and privacy-first handling of your data' }
];

export const performanceBenefits = [
  { id: 1, title: 'Made to Play', description: 'Every instrument is picked for real tone, response and reliability' },
  { id: 2, title: 'Detail Obsessed', description: 'Clean intonation, solid builds and player-friendly setups throughout' },
  { id: 3, title: 'Musician Approved', description: 'Gear that keeps beginners and gigging players in their flow' },
  { id: 4, title: 'Fair, Honest Pricing', description: 'Straightforward prices on the instruments you actually want' }
];

export const steps = [
  { id: 1, title: 'Browse', description: 'Explore our curated collection of instruments and music gear.' },
  { id: 2, title: 'Choose', description: 'Pick the strings, drums, woodwinds or studio gear that fits your sound.' },
  { id: 3, title: 'Checkout', description: 'Complete your order with fast, secure and encrypted payment.' },
  { id: 4, title: 'Play', description: 'Unbox, tune up and start making music with your new gear.' }
];
